// extracted by mini-css-extract-plugin
module.exports = {"list":"TickedList_list__2joT6","item":"TickedList_item__3nRPa","inset":"TickedList_inset__CTXaR"};